import React from 'react';
import ConfirmedTabs from '../confirmed-tabs';


const Confirmed: React.FC = () => {
    return <ConfirmedTabs />;
};

export default Confirmed;
